import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { resolvePanelHomePath } from '@/application/navigation/menuHouses';
import { usePermissions } from '@/presentation/contexts/permissionsContextCore';

type CoofitLogoHomeButtonProps = {
  className?: string;
};

/** Logo Coofit: navega a la home resuelta por permisos (US-122). */
export function CoofitLogoHomeButton({ className }: CoofitLogoHomeButtonProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { hasPermission, isOwner } = usePermissions();

  return (
    <button
      type="button"
      onClick={() => navigate(resolvePanelHomePath(hasPermission, isOwner))}
      className="inline-flex shrink-0 rounded-lg transition hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-500 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-gray-900"
      aria-label={t('notFound.backHome')}
    >
      <img src="/assets/images/coofit-logo.png" alt="Coofit" className={className} />
    </button>
  );
}
